import { render, staticRenderFns } from "./ActiveMaskingInstructionDetails.vue?vue&type=template&id=3efac62a&"
import script from "./ActiveMaskingInstructionDetails.vue?vue&type=script&lang=ts&"
export * from "./ActiveMaskingInstructionDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.8_m6jvttnwtqqy6l4pi5vsxiehsy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports